import React, { useContext, } from 'react'
import dynamic from 'next/dynamic'

import { MenuContext } from 'contexts/Menu'

import useIsMobile from 'hooks/useIsMobile'

import MenuHeader from '@/Menus/MenuHeader'
import Languages from '@/Languages'

import { StyledMenuModalContainer } from './styles'

const StandardModal = dynamic(() => import('./StandardModal'), { ssr: false, })

const MenuModal = () => {
  const {
    menuChangeHandler,
    menuOpen
  } = useContext(MenuContext)
  const isMobile = useIsMobile('middle')

  return (
    isMobile &&
    isMobile !== undefined &&
    <StandardModal
      wrapperId='menu-modal'
      isOpen={menuOpen}
      setIsOpen={menuChangeHandler}
      hideCloseButton
      wrapperProps={{
        exit: {
          opacity: 0,
          transition: {
            delay: 0.5, duration: 0.4
          }
        },
      }}
      containerProps={{
        css: {
          backgroundColor: '$background',
          height: '100%',
          with: '100%',
          display: 'block',
          transformOrigin: 'center left',
        },
        initial: { y: '100%', },
        animate: { y: '0%', },
        exit: {
          y: '100%',
          transition: {
            delay: 0.6, duration: 0.4
          }
        },
        transition: {
          type: 'spring',
          duration: 0.4,
          mass: 0.1
        }
      }}
    >
      <StyledMenuModalContainer>
        <MenuHeader />
        <Languages className="MobileLanguages" theme="boxed" />
      </StyledMenuModalContainer>
    </StandardModal>
  )
}

export default MenuModal
